import 'wix-rich-content-common';
import React from 'react';
import { Decoration_Type } from 'ricos-schema';

const TEXT_COLOR_TYPE = "wix-rich-content-text-color";
const TEXT_HIGHLIGHT_TYPE = "wix-rich-content-text-highlight";

let userColors = [];
const DEFAULTS = {
  configTextColor: {
    editor: {
      onColorAdded: (color) => userColors = [...userColors, color],
      getUserColors: () => userColors
    },
    viewer: {}
  },
  configTextHighlight: {
    editor: {
      onColorAdded: (color) => userColors = [...userColors, color],
      getUserColors: () => userColors
    },
    viewer: {}
  }
};

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const TO_PROPERTY = {
  [TEXT_COLOR_TYPE]: "color",
  [TEXT_HIGHLIGHT_TYPE]: "backgroundColor"
};
const decorator = (element, colorDecoration, context) => {
  const shouldParseColor = (type, color) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = context.config) == null ? void 0 : _a[type]) == null ? void 0 : _b.styleSelectionPredicate) == null ? void 0 : _c.call(_b, color);
  };
  const parseColor = (type, color) => {
    var _a, _b;
    return (_b = (_a = context.config) == null ? void 0 : _a[type]) == null ? void 0 : _b.customStyleFn(color);
  };
  const getColor = (type, color) => {
    return shouldParseColor(type, color) ? parseColor(type, color) : { [TO_PROPERTY[type]]: color };
  };
  const { foreground, background } = (colorDecoration == null ? void 0 : colorDecoration.colorData) || {};
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      key: `color-${element.key}`,
      style: __spreadProps(__spreadValues$1(__spreadValues$1({}, getColor(TEXT_COLOR_TYPE, foreground)), getColor(TEXT_HIGHLIGHT_TYPE, background)), {
        textDecoration: "inherit"
      })
    },
    element
  );
};
const ColorDecorator = {
  rule: (node) => {
    var _a, _b;
    return !!((_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.some(({ type }) => type === Decoration_Type.COLOR));
  },
  decorate: ({ element, node, context }) => {
    var _a, _b;
    const colorDecoration = (_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.find(
      ({ type }) => type === Decoration_Type.COLOR
    );
    return decorator(element, colorDecoration, context);
  }
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginTextColor = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.configTextColor.viewer), config),
    type: TEXT_COLOR_TYPE,
    nodeViewDecorators: [ColorDecorator]
  };
};
const pluginTextHighlight = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.configTextHighlight.viewer), config),
    type: TEXT_HIGHLIGHT_TYPE
  };
};

export { TEXT_COLOR_TYPE, TEXT_HIGHLIGHT_TYPE, pluginTextColor, pluginTextHighlight };
//# sourceMappingURL=viewer.js.map
